var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.time)?_c('recipe-label',{attrs:{"value":_vm.time,"icon":"far fa-clock"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }